import React from 'react';
import { ReactComponent as Ads } from './ads.svg';
import { ReactComponent as Analytics } from './analytics.svg';
import { ReactComponent as HelpCenter } from './help-center.svg';
import { ReactComponent as Moments } from './moments.svg';
import { ReactComponent as Settings } from './settings.svg';
import { ReactComponent as Topics } from './topics.svg';

const listModalData = [
	{
		link: 'Find Creators',
		icon: <Moments />,
		href: 'https://www.69work.com/marketplace/',
		divider: false,
	},
	{
		link: 'Wishlist',
		icon: <Topics />,
		href: '/wishlist',
		divider: false,
	},
	{
		link: 'Become A Seller',
		icon: <Analytics />,
		href: '/sell',
		divider: false,
	},
	{
		link: 'Settings',
		icon: <Settings />,
		href: '/marketplace/settings/',
		divider: true,
	},
	{
		link: 'Help Center',
		icon: <HelpCenter />,
		href: 'https://help.69work.com',
		divider: false,
	},
	{
		link: 'Feedback',
		icon: <Ads />,
		href: 'https://www.69work.com/marketplace/contact',
		divider: false,
	},
];

export default listModalData;
